<div [classList]="Canvas">
    <!-- <div id="mySidepanel" class="sidepanel sidepanel-mini"> -->
        <div id="mySidepanel" [classList]="open">
        <form id="form1">
            <div fxLayout="column wrap">
                <div class="headContent">
                    <span class="head"> <b>User Details</b></span>
                    <i id="closeX" (click)="closeUserSidePanel()" class="flaticon-close"></i>
                </div>
                <ng-container *ngIf="!isCustomer">
                    <logzy-user-form [isEditable]="isEditable" [userObject]="selectedUser"
                        (closeForm)="onUserChange($event)" [errorObj]="defaultErrorObj">
                    </logzy-user-form>
                </ng-container>
                <ng-container *ngIf="isCustomer">
                    <logzy-user-form-external [isEditable]="isEditable" [patchExternalUser]="selectedExternalUser"
                        (closeForm)="onUserChange($event)"></logzy-user-form-external>
                </ng-container>
            </div>
        </form>
    </div>
</div>
<mat-tab-group [selectedIndex]="selectedTab">
    <mat-tab label="My Profile">
        <my-profile fxFlex="100" fxLayout="row wrap"></my-profile>
    </mat-tab>
    <mat-tab label="My Team">
        <my-team (canvas)="setCanvas($event)" (open)="setOpen($event)" (patchUserForm)="editUser($event)" (viewUserForm)="editable($event)"
            (clearErrorsOnFormOpen)="clearError($event)" (patchExternalUserForm)="editExternalUser($event)"
            [forceRefreshMyTeamList]="refreshTable"></my-team>
    </mat-tab>
    <!-- <mat-tab label="Notification Preference" *ngIf="!isCustomer">
        <notification-preference></notification-preference>
    </mat-tab> -->
    <mat-tab label="My Preferences" *ngIf="!isCustomer">
        <!-- <business-preference></business-preference> -->
        <logzy-my-preferences></logzy-my-preferences>
    </mat-tab>
    <mat-tab label="Privacy and Security">
        <privacy-n-security></privacy-n-security>
    </mat-tab>
    <!-- <mat-tab label="Devices" *ngIf="!isCustomer">
        <devices></devices>
    </mat-tab> -->
    <mat-tab label="Login Activity">
        <login-activity></login-activity>
    </mat-tab>
</mat-tab-group>
